import API from '@/services/api'

// Actions
export const FETCH_ADDRESS = 'fetchAddress'
export const LOOKUP_ADDRESS = 'lookupAddress'

const actions = {
	[FETCH_ADDRESS] (context, address) {
		return new Promise((resolve, reject) => {
			API.post('address', address).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},

	[LOOKUP_ADDRESS] (context, address) {
		return new Promise((resolve, reject) => {
			API.post('address/lookup', address).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

export default { actions }